export default __webpack_public_path__ + "static/media/ico-home-de.08914520.svg";